export default [
    {
        path: "/dashboard",
        name: "home",
        component: () =>
            import(/* webpackChunkName: "home" */ "../pages/dashboard/HomeView.vue"),
        meta: {
            title: "Dashboard",
        },
    }
];
